<div class="wrapper">
    <div class="page-wrapper pt-4">
        <div class="page-content pt-0 px-2">
            <div class="container-fluid">
                <div class="content-wrapper p-0">
                    <!-- <body> -->
                    <!-- <div class="dashboard-header">

                                    Institution Overview Dashboard
                                </div>
                                <div class="dashboard-box mb-2">
                                    <div class="filters p-2">
                                        <div class="row m-auto justify-content-center">
                                            <div class="col-md-3">
                                                <select class="form-select form-select-sm">
                                                    <option>Country: All</option>
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <select class="form-select form-select-sm">
                                                    <option>Date: Jan 2022 - Dec 2022</option>
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <select class="form-select form-select-sm">
                                                    <option>Type: All Institutions</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                </div> -->
                    <!-- Main box -->
                    <div class="dashboard-box">
                        <!-- Stats -->
                        <!-- <div class="row g-0 text-center border-top border-bottom">
                           
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Total Institutions</div>
                                    <div class="fw-semibold fs-5" style="cursor: pointer;" data-bs-toggle="modal"
                                        data-bs-target="#totalInstitutionsModal">
                                        {{dbDetails?.TOTA_APPROVED_INST ?? 0}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Approved Institutions</div>
                                    <div class="fw-semibold fs-5" style="cursor: pointer;" (click)="navigationTLUrl(2)">
                                        {{dbDetails?.TOTA_ACTIVE_INST ?? 0}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Total Students</div>
                                    <div class="fw-semibold fs-5" style="cursor: pointer;" (click)="navigationTLUrl(3)">
                                        {{dbDetails?.TOTAL_STUDENTS ?? 0}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Rejected Institutions</div>
                                    <div class="fw-semibold fs-5 text-warning" style="cursor: pointer;"
                                        (click)="navigationTLUrl(4)">
                                        {{dbDetails?.TOTA_REJECTED_INST ?? 0}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Institutions Applications</div>
                                    <div class="fw-semibold fs-5" style="cursor: pointer;" (click)="navigationTLUrl(5)">
                                        {{dbDetails?.TOTAL_REGISTRATION_INST ?? 0}}
                                    </div>
                                </div>
                            </div>
                           
                        </div> -->
                        <div class="row g-0 text-center border-top border-bottom">
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Total Institutions</div>
                                    <div class="fw-semibold fs-5" style="cursor: pointer;"
                                        (click)="openModal('totalInstitutions', 'Total Institutions')">
                                        {{dbDetails?.TOTA_APPROVED_INST ?? 0}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Approved Institutions</div>
                                    <div class="fw-semibold fs-5" style="cursor: pointer;"
                                        (click)="openModal('approvedInstitutions', 'Approved Institutions')">
                                        {{dbDetails?.TOTA_ACTIVE_INST ?? 0}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Total Students</div>
                                    <div class="fw-semibold fs-5" style="cursor: pointer;"
                                        (click)="openModal('totalStudents', 'Total Students')">
                                        {{dbDetails?.TOTAL_STUDENTS ?? 0}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Rejected Institutions</div>
                                    <div class="fw-semibold fs-5 text-warning" style="cursor: pointer;"
                                        (click)="openModal('rejectedInstitutions', 'Rejected Institutions')">
                                        {{dbDetails?.TOTA_REJECTED_INST ?? 0}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Institutions Applications</div>
                                    <div class="fw-semibold fs-5" style="cursor: pointer;"
                                        (click)="openModal('institutionApplications', 'Institutions Applications')">
                                        {{dbDetails?.TOTAL_REGISTRATION_INST ?? 0}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Special Need Schools</div>
                                    <div class="fw-semibold fs-5" style="cursor: pointer;"
                                        (click)="openModal('specialNeedSchools', 'Special Need Schools')">
                                        {{dbDetails?.SPECIAL_NEED_SCHOOLS ?? 0}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-2 mb-2">
                        <div class="accordion accordion-flush" id="customAccordion">
                            <div class="row">
                                <div class="col-xl-6">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                (click)="toggleAccordion(1)" [class.collapsed]="!isAccordionOpen(1)"
                                                [attr.aria-expanded]="isAccordionOpen(1)" aria-controls="collapseOne">
                                                <span>{{ columnConfigration.institutionSummary.title }}</span>
                                                <span class="badge bg-primary ms-2"
                                                    *ngIf="isAccordionOpen(1) && !isLoading1 && accordionLoaded[1]">
                                                    <i class="fas fa-check-circle"></i> Loaded
                                                </span>
                                                <span class="badge bg-warning ms-2" *ngIf="isLoading1">
                                                    <i class="fas fa-spinner fa-spin"></i> Loading...
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse"
                                            [class.show]="isAccordionOpen(1)">
                                            <div class="accordion-body">
                                                <div class="d-flex justify-content-end mb-2">
                                                    <button class="btn btn-sm btn-primary" (click)="refreshReport(1)"
                                                        [disabled]="isLoading1">
                                                        <i class="fas fa-sync-alt me-1"
                                                            [class.fa-spin]="isLoading1"></i>
                                                        {{ isLoading1 ? 'Loading...' : 'Refresh' }}
                                                    </button>
                                                </div>

                                                <!-- ✅ ACCORDION SPINNER - Same as global spinner -->
                                                <div *ngIf="isLoading1" class="accordion-spinner-wrapper">
                                                    <div class="accordion-spinner-overlay">
                                                        <div class="line-scale">
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="table-responsive"
                                                    *ngIf="summaryReportList1.length > 0 && !isLoading1">
                                                    <table class="table table-striped table-hover table-sm small"
                                                        style="width: 100%; white-space: nowrap">
                                                        <thead
                                                            style="background-color: #624fd7; color: #ffffff !important">
                                                            <tr>
                                                                <th *ngFor="let column of summaryModalColumns1"
                                                                    class="text-center py-2"
                                                                    [class.total-column]="isTotalColumn(column)">
                                                                    {{ column }}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let item of summaryReportList1; let i = index"
                                                                [ngClass]="{
                                                'table-total-row': isTotalRow(i, 1)
                                            }">
                                                                <td *ngFor="let column of summaryModalDataKeys1; let j = index"
                                                                    class="text-center py-1" [ngClass]="{
                                                    'fw-bold': isBoldCell(i, summaryModalColumns1[j], 1)
                                                }">
                                                                    {{ getSummaryReportColumnValue(item, column) }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div *ngIf="summaryReportList1.length === 0 && !isLoading1 && accordionLoaded[1]"
                                                    class="text-center py-3">
                                                    <p class="text-muted">No data available</p>
                                                </div>
                                                <div *ngIf="!accordionLoaded[1] && !isLoading1"
                                                    class="text-center py-3">
                                                    <p class="text-muted">Click to load data</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-6">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                (click)="toggleAccordion(2)" [class.collapsed]="!isAccordionOpen(2)"
                                                [attr.aria-expanded]="isAccordionOpen(2)" aria-controls="collapseTwo">
                                                <span>{{ columnConfigration.learnerSummary.title }}</span>
                                                <span class="badge bg-primary ms-2"
                                                    *ngIf="isAccordionOpen(2) && !isLoading2 && accordionLoaded[2]">
                                                    <i class="fas fa-check-circle"></i> Loaded
                                                </span>
                                                <span class="badge bg-warning ms-2" *ngIf="isLoading2">
                                                    <i class="fas fa-spinner fa-spin"></i> Loading...
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" class="accordion-collapse collapse"
                                            [class.show]="isAccordionOpen(2)">
                                            <div class="accordion-body">
                                                <div class="d-flex justify-content-end mb-2">
                                                    <button class="btn btn-sm btn-primary" (click)="refreshReport(2)"
                                                        [disabled]="isLoading2">
                                                        <i class="fas fa-sync-alt me-1"
                                                            [class.fa-spin]="isLoading2"></i>
                                                        {{ isLoading2 ? 'Loading...' : 'Refresh' }}
                                                    </button>
                                                </div>

                                                <!-- ✅ ACCORDION SPINNER - Same as global spinner -->
                                                <div *ngIf="isLoading2" class="accordion-spinner-wrapper">
                                                    <div class="accordion-spinner-overlay">
                                                        <div class="line-scale">
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="table-responsive"
                                                    *ngIf="summaryReportList2.length > 0 && !isLoading2">
                                                    <table class="table table-striped table-hover table-sm small"
                                                        style="width: 100%; white-space: nowrap">
                                                        <thead
                                                            style="background-color: #624fd7; color: #ffffff !important">
                                                            <tr>
                                                                <th *ngFor="let column of summaryModalColumns2"
                                                                    class="text-center py-2"
                                                                    [class.total-column]="isTotalColumn(column)">
                                                                    {{ column }}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let item of summaryReportList2; let i = index"
                                                                [ngClass]="{
                                                'table-total-row': isTotalRow(i, 2)
                                            }">
                                                                <td *ngFor="let column of summaryModalDataKeys2; let j = index"
                                                                    class="text-center py-1" [ngClass]="{
                                                    'fw-bold': isBoldCell(i, summaryModalColumns2[j], 2)
                                                }">
                                                                    {{ getSummaryReportColumnValue(item, column) }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div *ngIf="summaryReportList2.length === 0 && !isLoading2 && accordionLoaded[2]"
                                                    class="text-center py-3">
                                                    <p class="text-muted">No data available</p>
                                                </div>
                                                <div *ngIf="!accordionLoaded[2] && !isLoading2"
                                                    class="text-center py-3">
                                                    <p class="text-muted">Click to load data</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class=" mt-2 mb-2">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card">
                                    <div class="card-header bg-white fw-bold">Country Overview</div>
                                    <div class="card-body">
                                        <div class="row g-4">
                                            <!-- LEFT MAP CARD -->
                                            <div class="col-lg-7">
                                                <div class="card h-100">
                                                    <!-- <div #mapContainer style="height: 600px; width: 100%;"></div> -->
                                                    <div class="map-wrapper">
                                                        <div #mapContainer class="map-container"></div>
                                                    </div>

                                                </div>
                                                <!-- Replace image with actual SVG map if needed -->
                                            </div>
                                            <!-- RIGHT LINE CHART -->
                                            <div class="col-lg-5">
                                                <div class="row">
                                                    <div class="col-xl-12 mb-2">
                                                        <div class="card h-100">
                                                            <div class="card-header bg-white">
                                                                <div class="card-title mb-0"> <strong> Top Counties by
                                                                        Institutions </strong></div>
                                                            </div>
                                                            <div class="card-body">
                                                                <canvas id="barChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-12">
                                                        <div class="card h-100">
                                                            <div class="card-header bg-white">
                                                                <div class="card-title mb-0"> <strong> Monthly
                                                                    </strong> by Institutions</div>
                                                            </div> `
                                                            <div class="card-body">
                                                                <canvas id="lineChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- BAR CHART -->
                                            <!-- <div class="col-lg-6">
                                                        <div class="row">
                                                            <div class="col-xl-12">
                                                                <div class="card h-100">
                                                                    <div class="card-header bg-white">
                                                                        <div class="card-title mb-0"> <strong> Top Counties by
                                                                            Institutions </strong></div>
                                                                    </div>
                                                                    <div class="card-body">
                                                                        <canvas id="barChart"></canvas>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> -->
                                            <!-- REGISTRATION TREND -->
                                            <div class="col-lg-12">

                                                <div class="card h-100">
                                                    <div class="card-header bg-white">
                                                        <div class="card-title mb-0"> <strong> Onboardings
                                                                Trend </strong></div>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-md-6">
                                                                <canvas id="barChartmonth"></canvas>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <canvas id="donutChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 mb-2">
                            <div class="col-xl-12">
                                <div class="card h-100 bg-transparent">
                                    <div class="card-header bg-white">
                                        <div class="card-title mb-0"> <strong> Central County Overview </strong>
                                        </div>
                                    </div>
                                    <div class="card-body bg-transparent">
                                        <div class="row">
                                            <div class="col-xl-6">
                                                <div class="card p-2" *ngIf="selectedCounty">
                                                    <small>County Level - <strong>{{ selectedCounty }}
                                                            County</strong></small>
                                                    <hr class="mt-0 mb-2">
                                                    <!-- <div #subMapContainer class="mt-3" style="height: 400px;"></div> -->
                                                    <div class="map-wrapper1">
                                                        <div #subMapContainer class="mt-3 map-container1"></div>
                                                    </div>
                                                    <!-- <div *ngIf="selectedCounty" class="mt-3">
                                                        <h5>{{ selectedCounty }} Sub-Counties</h5>
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="col-xl-6">
                                                <!-- STATS -->
                                                <div class="row">
                                                    <div class="col-12 col-xl-6">
                                                        <div class="card stat-card">
                                                            <small>Total Institutions</small>
                                                            <hr class="mt-0 mb-0">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center">
                                                                <h4>{{countyDetails?.TOTAL_REGISTRATION_INST ?? 0}}</h4>
                                                                <span><i class="bi bi-bar-chart-fill"
                                                                        style="color: #2c67a5;"></i></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-xl-6">
                                                        <div class="card stat-card">
                                                            <small>Active Institutions</small>
                                                            <hr class="mt-0 mb-0">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center">
                                                                <h4>{{countyDetails?.TOTA_ACTIVE_INST ?? 0}}</h4>
                                                                <span><i
                                                                        class="bi bi-bar-chart-fill text-warning"></i></span>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-xl-6 mt-2">
                                                        <div class="card stat-card">

                                                            <small>Total Users</small>
                                                            <hr class="mt-0 mb-0">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center">
                                                                <h4>{{countyDetails?.TOTAL_STUDENTS ?? 0}}</h4>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-xl-6 mt-2">
                                                        <div class="card stat-card">
                                                            <small>New Onboardings</small>
                                                            <hr class="mt-0 mb-0">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center">
                                                                <h4>{{countyDetails?.TOTA_NEW_REGISTRATIONS ?? 0}}</h4>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- CHARTS -->
                                                <div class="row g-2 mt-2">
                                                    <!-- BAR 1 -->
                                                    <div class="col-md-6 mb-2">
                                                        <div class="card h-100">
                                                            <div class="card-header bg-white fw-semibold">
                                                                Sub-County Student Breakdown
                                                            </div>
                                                            <div class="card-body d-flex align-items-center">
                                                                <canvas id="breakdownbarChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- BAR 2 -->
                                                    <div class="col-md-6 mb-2">
                                                        <div class="card h-100">
                                                            <div class="card-header bg-white fw-semibold">
                                                                Institutions by Sub-County
                                                            </div>
                                                            <div class="card-body d-flex align-items-center">
                                                                <canvas id="institutionsbarChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- DONUT -->
                                                    <div class="col-md-12 mb-2">
                                                        <div class="card h-100">
                                                            <div class="card-header bg-white fw-semibold">
                                                                Institution Types
                                                            </div>
                                                            <div class="card-body d-flex align-items-center">
                                                                <canvas id="subCountyDonutChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- TOP SECTION -->
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card h-100">
                                    <div class="card-header bg-white">
                                        <div class="card-title mb-0"> <strong>Institution List</strong></div>
                                    </div>
                                    <div class="card-body">
                                        <div class="d-flex justify-content-end mb-2">
                                            <div style="width: 250px;">
                                                <input type="text" class="form-control" placeholder="Search"
                                                    [(ngModel)]="srchFltr"
                                                    (keyup)="searchByData($event.target.value)" />
                                            </div>
                                        </div>
                                        <div class="table-responsive" *ngIf="institutionsList.length">
                                            <table class="table table-sm align-middle small table-striped"
                                                style="width: 100%;white-space: nowrap;">
                                                <thead class="bg-light">
                                                    <tr>
                                                        <th class="bg-light">S.No</th>
                                                        <th class="bg-light">Institution Name</th>
                                                        <th class="bg-light"> Type</th>
                                                        <th class="bg-light">Students</th>
                                                        <th class="bg-light">Active Students</th>
                                                        <th class="bg-light">Application Status</th>
                                                        <th class="bg-light">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let item of institutionsList| paginate: { id: 'tblscLst', itemsPerPage: pgSze, currentPage: crntPage, totalItems: ttlItms }; let i = index">
                                                        <td>{{(pgSze*(crntPage-1))+i+1}}</td>
                                                        <td>{{item.INSTITUTION_NAME}}</td>
                                                        <td>{{item.INSTITUTION_TYPE}}</td>
                                                        <td>{{item.TOTAL_STUDENTS}}</td>
                                                        <td>{{item.TOTAL_ACTIVE_STUDENTS}}</td>
                                                        <td>{{item.INSTITUTION_STATUS}}</td>
                                                        <td><span
                                                                class="status-active">{{item.INSTITUTION_STATUS}}</span>
                                                        </td>
                                                    </tr>


                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="text-center" *ngIf="!institutionsList.length">
                                            No Records to Display
                                        </div>
                                        <div class="col-xl-12" *ngIf="institutionsList.length!=0">
                                            <div class="row mb-0">
                                                <div class="col-xl-6">
                                                    <div class="mt-2">{{pageEntry}}</div>
                                                </div>
                                                <div class="col-xl-6 text-end">
                                                    <pagination-controls previousLabel="" id="tblscLst" nextLabel=""
                                                        (pageChange)="setPageNumber($event)"></pagination-controls>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="table-responsive">
                                            <table class="table table-sm align-middle small table-striped">
                                                <thead class="bg-light">
                                                    <tr>
                                                        <th class="bg-light">Institution Name</th>
                                                        <th class="bg-light"> Type</th>
                                                        <th class="bg-light">Students</th>
                                                        <th class="bg-light">Active Students</th>
                                                        <th class="bg-light">Application Status</th>
                                                        <th class="bg-light">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody *ngIf="institutionsList.length !=0">
                                                    <tr *ngFor="let item of institutionsList">
                                                        <td>{{item.INSTITUTION_NAME}}</td>
                                                        <td>{{item.INSTITUTION_TYPE}}</td>
                                                        <td>{{item.TOTAL_STUDENTS}}</td>
                                                        <td>{{item.TOTAL_ACTIVE_STUDENTS}}</td>
                                                        <td>{{item.INSTITUTION_STATUS}}</td>
                                                        <td><span
                                                                class="status-active">{{item.INSTITUTION_STATUS}}</span>
                                                        </td>
                                                    </tr>


                                                </tbody>
                                            </table>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-xl-12">
                                <div #mapContainer style="height: 600px; width: 100%;"></div>
                            </div>
                            <div class="col-xl-12">
                                <div *ngIf="selectedCounty" class="mt-3">
                                    <h5>{{ selectedCounty }} Sub-Counties</h5>
                                    <div #subMapContainer style="height: 400px;"></div>
                                </div>
                            </div> -->
                        </div>
                        <!-- TABLE -->
                    </div>
                    <!-- </body> -->
                </div>
            </div>
        </div>
    </div>
</div>


<!-- <div class="modal" id="dynamicModal" data-backdrop="static" data-keyboard="false"> -->
<div class="modal fade" id="dynamicModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header py-2">
                <h6 class="modal-title w-100">{{ modalTitle }}</h6>
                <button type="button" (click)="closeModal()" class="close" data-bs-dismiss="modal">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div *ngIf="gridList.length != 0" class="d-flex justify-content-between align-items-center mb-2">

                    <!-- Left Side -->
                    <div class="dropdown">
                        <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Download
                        </button>

                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                                <a class="dropdown-item" (click)="downloadPDF('excel', currentModalType)">
                                    Excel
                                </a>
                            </li>

                            <li>
                                <a class="dropdown-item" (click)="downloadPDF('pdf', currentModalType)">
                                    PDF
                                </a>
                            </li>
                        </ul>
                    </div>

                    <!-- Right Side -->
                    <div style="width: 250px;">
                        <input type="text" class="form-control" placeholder="Search" [(ngModel)]="srchFltr"
                            (keyup)="search($event.target.value, modalTitle)">
                    </div>

                </div>

                &nbsp;
                <div class="table-responsive" *ngIf="gridList.length != 0">
                    <table class="table-striped mt-2 pt-2 table-sm small" style="width: 100%; white-space: nowrap">
                        <thead class="top" style="background-color: #624fd7; color: #ffffff !important">
                            <tr>
                                <th>S.No</th>
                                <th *ngFor="let column of modalColumns">{{ column }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let item of gridList | paginate: { id: 'tblscLst', itemsPerPage: pgSze, currentPage: crntPage, totalItems: ttlItms }; let i = index">

                                <td>{{(pgSze*(crntPage-1))+i+1}}</td>
                                <td *ngFor="let column of modalDataKeys">{{ getColumnValue(item, column) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-xl-12" *ngIf="gridList.length!=0">
                    <div class="row mb-0">
                        <div class="col-xl-6">
                            <div class="mt-2">{{pageEntry}}</div>
                        </div>
                        <div class="col-xl-6 text-end">
                            <pagination-controls previousLabel="" id="tblscLst" nextLabel=""
                                (pageChange)="setPage($event, modalTitle)"></pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" id="md_close" (click)="closeModal()"
                    data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>